import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { PopupTriggerProps } from '@atlassian/jira-development-board-common/src/types.tsx';
import parameters from '@atlassian/jira-relay/src/__generated__/DeploymentDetailsPopupQuery$parameters';
import type { DeploymentDetailsPopupQuery } from '@atlassian/jira-relay/src/__generated__/DeploymentDetailsPopupQuery.graphql.ts';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

/**
 * @deprecated This component is deprecated. Please use the component from
 * "@atlassian/jira-development-board-deployment-details-popup-new" package instead.
 */
export const deploymentDetailsEntryPoint: EntryPoint<
	EntryPointComponent<
		{
			deployments: DeploymentDetailsPopupQuery;
		},
		{},
		PopupTriggerProps,
		{}
	>,
	{
		issueId: string;
	}
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-deployment-details-popup" */ './src/ui/DeploymentDetailsPopup.tsx'
			),
	),
	getPreloadProps: ({ issueId }: { issueId: string }) => ({
		queries: {
			deployments: {
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				parameters,
				variables: {
					issueAris: [issueId],
				},
			},
		},
	}),
});
